import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import {ApiNotificationResponseDto} from '@birco/rainmesh-api';
import {Router} from '@angular/router';
import {IconComponent} from '../../../../shared/icons/icon.component';
import {IconsPipe} from '../../../../shared/pipes/icons.pipe';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {TagComponent} from '../../../../shared/components/tag/tag.component';
import {RelativeDatePipe} from '../../../../shared/pipes/relative-date.pipe';
import {LabelConverter} from '../../../../shared/converter/label.converter';
import {getNotificationContent} from '../../utils/notification-utils';
import { LocalizedDatePipe } from "../../../../shared/pipes/localized-date.pipe";
import { TimePipe } from "../../../../shared/pipes/time.pipe";

@Component({
  selector: '[app-notification-item-row]',
  imports: [
    IconComponent,
    IconsPipe,
    TranslatePipe,
    TagComponent,
    LocalizedDatePipe,
    TimePipe
],
  templateUrl: './notification-item-row.component.html',
  styleUrl: './notification-item-row.component.scss'
})
export class NotificationItemRowComponent {
  private router = inject(Router);
  private translateService = inject(TranslateService);

  @Input() isHeader = false;
  @Input() notification?: ApiNotificationResponseDto
  @Output() markAsRead = new EventEmitter<string>()

  get notificationContent() {
    return getNotificationContent(this.notification, this.translateService)
  }

  get hasLink() {
    return !!this.notificationContent.routerLink
  }

  onMarkAsRead() {
    if (this.notification?.readAt) return;

    this.markAsRead.emit(this.notification!.id);
  }

  async markAsReadAndNavigateToRouterLink() {
    if (!this.hasLink) return;

    this.markAsRead.emit(this.notification!.id)
    await this.router.navigate(this.notificationContent.routerLink!)
  }

  protected readonly LabelConverter = LabelConverter;
}
